export const LOGIN_PROCESS = "LOGIN_PROCESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";

export const LOGOUT_PROCESS = "LOGOUT_PROCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const GET_USER_INFO_SUCCESS = "GET_USER_INFO_SUCCESS";
export const GET_USER_INFO_FAIL = "GET_USER_INFO_FAIL";

export const GET_REFRESH_TOKEN_SUCCESS = "GET_REFRESH_TOKEN_SUCCESS";
export const GET_REFRESH_TOKEN_FAIL = "GET_REFRESH_TOKEN_FAIL";

export const RESET_STATUS = "RESET_STATUS";
